// Slug helpers — shared so they're unit-testable.

// "John Doe" -> "john-doe". Full clean, for deriving a slug from a name.
export function deriveSlug(name: string): string {
  return name.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

// Lenient sanitizer for manual slug/project typing (keeps in-progress hyphens).
export function sanitizeSlug(raw: string): string {
  return raw.toLowerCase().replace(/[^a-z0-9-]+/g, '-');
}
